export default {
  HOME: "Home",
  QUICK_QUIZ: "Quick Quiz",
  SKIP: "Skip"
};
